export default __webpack_public_path__ + "static/media/card-automobile.e99726cc.png";